import { useEffect } from 'react'

export const crosses = [
  'https://cdn.thingtesting.com/assets/select-crosses/cross-1.png',
  'https://cdn.thingtesting.com/assets/select-crosses/cross-2.png',
  'https://cdn.thingtesting.com/assets/select-crosses/cross-3.png',
  'https://cdn.thingtesting.com/assets/select-crosses/cross-4.png',
  'https://cdn.thingtesting.com/assets/select-crosses/cross-5.png'
]

const allImages = [...crosses]

export const UiImagePreloader = () => {
  // On page mount, preload all images which might be needed
  // to render the UI
  useEffect(() => {
    allImages.forEach((img) => {
      new Image().src = img
    })
  }, [])

  return null
}
